import { FiservFieldName, HTMLFieldIDs } from "../../../fiserv/card/types";

export const errorSlot = (id: FiservFieldName | HTMLFieldIDs, message: string, isWarning: boolean) =>
  `<div class="error-slot" id="${id}Error"><svg class="error-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" fill=${isWarning ? '#FFAB48' : '#F04C27'
  } /><path d="M12 12.999C12.3086 12.999 12.465 12.8099 12.4691 12.4316L12.5617 8.63924C12.5658 8.45729 12.5123 8.30645 12.4012 8.18675C12.2942 8.06225 12.1584 8 11.9938 8C11.8251 8 11.6872 8.05985 11.5802 8.17956C11.4774 8.29927 11.428 8.4501 11.4321 8.63206L11.5123 12.4316C11.5206 12.8099 11.6831 12.999 12 12.999ZM12 15.3333C12.177 15.3333 12.3313 15.2615 12.463 15.1179C12.5988 14.9742 12.6667 14.797 12.6667 14.5864C12.6667 14.3757 12.6008 14.1985 12.4691 14.0548C12.3375 13.9112 12.1811 13.8394 12 13.8394C11.8189 13.8394 11.6626 13.9136 11.5309 14.062C11.3992 14.2057 11.3333 14.3805 11.3333 14.5864C11.3333 14.7923 11.3992 14.9694 11.5309 15.1179C11.6626 15.2615 11.8189 15.3333 12 15.3333Z" fill="white"/></svg><span>${message}</span></div>`;

export const showErrorMessage = ({
  input,
  id,
  message,
  isWarning
}: { input: HTMLElement; id: FiservFieldName | HTMLFieldIDs; message: string; isWarning?: boolean }) => {
  const errorElement = document.getElementById(`${id}Error`);
  if (errorElement) return

  (input.parentNode as HTMLElement)?.insertAdjacentHTML(
    'afterbegin',
    errorSlot(id, message, isWarning ?? false)
  );
};

export const removeErrorMessage = ({ id }: { id: FiservFieldName | HTMLFieldIDs }) => {
  const errorElement = document.getElementById(`${id}Error`);
  if (errorElement) errorElement.remove();
};
